import * as React from 'react';
import { EntityUserRole } from '../../redux/ContactSlice';
import { UserRoleEnum } from '../../redux/UserSlice';
import CertificationCore from '../AfrCore/CertificationCore';

const CR29Certification = (props: any) => {

    return (
        <React.Fragment>
            <CertificationCore userRole={UserRoleEnum.Admin} />
        </React.Fragment>
    );
}

export default CR29Certification;